import { useMemo } from 'react'
import { useGetConsultants } from './useGetConsultants'
import { Consultant } from '../queries'

type ClinicianOption = Consultant & { full_name: string }

export const useClinicianLookup = () => {
  const { data: consultants, loading, error } = useGetConsultants()

  const clinicianMap = useMemo(() => {
    const map = new Map<string, Consultant>()
    consultants?.forEach((consultant) => {
      if (consultant?.uuid) {
        map.set(consultant.uuid, consultant)
      }
    })
    return map
  }, [consultants])

  const clinicianOptions = useMemo(
    () =>
      (consultants || []).filter((c): c is ClinicianOption => !!c.full_name),
    [consultants]
  )

  const getClinician = (clinicianUuid: string): Consultant | undefined =>
    clinicianMap.get(clinicianUuid)

  const getSelectedClinician = (
    clinicianUuid: string
  ): ClinicianOption | null =>
    clinicianOptions.find((c) => c.uuid === clinicianUuid) ?? null

  return {
    getClinician,
    clinicianOptions,
    getSelectedClinician,
    loading,
    error,
  }
}
